import styled from '@emotion/styled';
import Link, { LinkProps } from 'next/link';

export type StyledLinkProps = LinkProps;

const StyledLink = styled(Link)<StyledLinkProps>(
  {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 12,
    paddingBottom: 12,
    borderRadius: 7,
    fontSize: 18,
    fontWeight: 400,
    gap: 5
  },
  ({ theme }) => ({
    color: theme.palette.colors.midnightBlue,
    backgroundColor: theme.palette.colors.antiFlash
  })
);

export default StyledLink;
